<template>
  <div class="page contracts-templates">
    <button class="btn btn-primary w-100" @click="$refs.files.click()">Загрузить шаблон</button>
    <input
      type="file"
      ref="files"
      @change="addFilesFromDialog"
      style="display:none"
      multiple
    />

    <ul class="nav nav-tabs mt-3">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ 'active': currentTab === 'contractTemplates' }"
            @click.prevent="setContractTemplatesTab"
            href="#contractTemplates"
          >Договоры</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ 'active': currentTab === 'receiveListsTemplates' }"
            @click.prevent="setReceiveListsTemplatesTab"
            href="#receiveListsTemplates"
          >Акты возврата</a>
        </li>
      </ul>
      <div class="tab-content">
        <!-- ШАБЛОНЫ ДОГОВОРОВ -->
        <div
          class="tab-pane fade"
          :class="{ 'active show': currentTab === 'contractTemplates' }"
          id="contractTemplates"
        >
          <div class="card file-card" v-for="file of contractTemplates" :key="file.id">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <font-awesome-icon
                    icon="file-word"
                    class="donload-icon"
                    :style="{ color: '#25559a' }"
                  />
                  {{ file.name }}
                </div>
                <div class="col-md-2 mb-6 date">
                  {{ file.created_at }}
                  <div class="deleteButton" @click="archivateFile(file.id)">
                    <font-awesome-icon
                      icon="trash-alt"
                      size="1x"
                      :style="{ color: 'gray' }"
                    />
                  </div>
                  <a class="downloadButton" :href="`/file/link?id=${file.id}`">
                    <font-awesome-icon
                      icon="download"
                      size="1x"
                      :style="{ color: 'gray' }"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /ШАБЛОНЫ ДОГОВОРОВ -->
        <!-- ШАБЛОНЫ АКТОВ ВОЗВРАТА -->
        <div
          class="tab-pane fade"
          :class="{ 'active show': currentTab === 'receiveListsTemplates' }"
          id="receiveListsTemplates"
        >
          <div class="card file-card" v-for="file of receiveListsTemplates" :key="file.id">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <font-awesome-icon
                    icon="file-word"
                    class="donload-icon"
                    :style="{ color: '#25559a' }"
                  />
                  {{ file.name }}
                </div>
                <div class="col-md-2 mb-6 date">
                  {{ file.created_at }}
                  <div class="deleteButton" @click="archivateFile(file.id)">
                    <font-awesome-icon
                      icon="trash-alt"
                      size="1x"
                      :style="{ color: 'gray' }"
                    />
                  </div>
                  <a class="downloadButton" :href="`/file/link?id=${file.id}`">
                    <font-awesome-icon
                      icon="download"
                      size="1x"
                      :style="{ color: 'gray' }"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /ШАБЛОНЫ АКТОВ ВОЗВРАТА -->
      </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import FilesAPI from '@/api/files'
export default {
  name: 'Templates',
  data () {
    return {
      files: [],
      inputFile: '',
      dragging: false,
      preDragging: false
    }
  },
  mounted () {
    this.loadAllTabs()
  },
  computed: {
    ...mapState('taxi/templates', {
      isLoading: state => state.isLoading,
      contractTemplates: state => state.contractTemplates,
      receiveListsTemplates: state => state.receiveListsTemplates,
      currentTab: state => state.currentTab
    })
  },
  beforeDestroy () {
    this.abortLoading()
  },
  methods: {
    ...mapActions('taxi/templates', [
      'loadCurrentTab',
      'setSearchText',
      'loadAllTabs',
      'setContractTemplatesTab',
      'setReceiveListsTemplatesTab',
      'abortLoading',
      'uploadTemplates'
    ]),
    addFilesFromDrop (e) {
      this.uploadTemplates(e.dataTransfer.files)
    },
    addFilesFromDialog (e) {
      this.uploadTemplates(e.target.files)
      this.$refs.files.value = null
    },

    getTemplate (id) {
      FilesAPI.getItem({ id: id }).then(template => {
        this.files.unshift(template)
      })
    },
    archivateFile (id) {
      FilesAPI.archivateItem(id).then(toRemove => {
        // TODO: оптимизировать
        this.loadAllTabs()
      })
    }
  },
  watch: {
    currentTab () {
      this.loadCurrentTab()
    }
  }
}
</script>
<style scoped>
  @media screen and (max-width: 1199px) {
    .page {
      padding: 1rem;
    }
  }
  @media screen and (max-width: 576px) {
    .page {
      padding: 0.5rem;
    }
  }
  .tab-content {
    z-index: 5;
  }
  .contracts-templates {
    width: 98%;
  }
  .date {
    min-width: 8rem;
  }
  .file-card {
    margin-top: 1rem;
  }
  .deleteButton {
    float: right;
  }
  .deleteButton:hover {
    cursor: pointer;
  }
  .downloadButton {
    float: right;
    margin-right: 25px;
  }
  .upload-button {
    float: right;
    width: 12.5rem;
  }
  .nav-tabs {
    border: none;
    z-index: 1;
  }
  .nav-item .nav-link {
    border: none;
    color: #212529;
  }
  .nav-item .nav-link.active {
    color: #0597f2;
    border-bottom: 2px solid #0597f2;
  }

</style>
